module.exports = __webpack_public_path__ + "img/copy.d0289dc0.png";